// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/delete_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.DeleteDailyItemRequest
 */
export class DeleteDailyItemRequest extends Message<DeleteDailyItemRequest> {
  /**
   * The ID of the daily item to delete
   *
   * @generated from field: int32 id = 1;
   */
  id = 0;

  constructor(data?: PartialMessage<DeleteDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DeleteDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDailyItemRequest {
    return new DeleteDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDailyItemRequest {
    return new DeleteDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDailyItemRequest {
    return new DeleteDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDailyItemRequest | PlainMessage<DeleteDailyItemRequest> | undefined, b: DeleteDailyItemRequest | PlainMessage<DeleteDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(DeleteDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.DeleteDailyItemResponse
 */
export class DeleteDailyItemResponse extends Message<DeleteDailyItemResponse> {
  constructor(data?: PartialMessage<DeleteDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DeleteDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDailyItemResponse {
    return new DeleteDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDailyItemResponse {
    return new DeleteDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDailyItemResponse {
    return new DeleteDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDailyItemResponse | PlainMessage<DeleteDailyItemResponse> | undefined, b: DeleteDailyItemResponse | PlainMessage<DeleteDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(DeleteDailyItemResponse, a, b);
  }
}

